<template>
    <div class="table-style table-style--default">
        <template v-for="item in items">
            <div class="table-style__row" :key="item.title">
                <div class="table-style__th">
                    {{ item.title }}
                </div>
                <div class="table-style__td">
                    {{ item.value }}
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { initUserVaccount } from "@/store/user-vaccounts";
export default {
    props: {
        vaccount: { type: Object, default: initUserVaccount },
    },
    data: () => ({}),
    computed: {
        items() {
            /** @type {import('@/store/user-vaccounts').UserVaccount}*/
            let { vaccount, waccount, expiresAt } = this.vaccount;

            let later_expiresAt = this.$dayjs.$toLater(expiresAt);

            return [
                {
                    title: "가상계좌",
                    value: vaccount,
                },
                {
                    title: "출금계좌",
                    value: waccount,
                },
                {
                    title: "유효기간",
                    value: `${expiresAt.toDateTime()} (${later_expiresAt})`,
                },
            ];
        },
    },
};
</script>

<style></style>
